import styled from 'styled-components';

export const Content = styled.div`
  position: absolute;
  top: 100%;
  border-radius: 0 0 10px 10px;
  right: 7px;
  padding: 5px;
  background: #171a1f;
  left: 7px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-shadow: 0 10px 20px 0 rgb(0 0 0 / 58%);
`;
